window.EG_HELP_CENTRE_ISSUES = {
  bind: function (ctx) {
    var form = ctx.form;
    var issueGroups = ctx.issueGroups;
    var successBox = ctx.successBox;
    var summaryEl = ctx.summaryEl;
    var currentCategoryRef = ctx.currentCategoryRef;
    var subjectEl = ctx.subjectEl;
    var issueCopy = ctx.issueCopy;
    var issueToFaq = ctx.issueToFaq;
    var orderNumberInput = ctx.orderNumberInput;
    var productNameBlock = ctx.productNameBlock;
    var productSerialBlock = ctx.productSerialBlock;
    var productNameInput = ctx.productNameInput;
    var productSerialInput = ctx.productSerialInput;
    var faultTimingBlock = ctx.faultTimingBlock;
    var faultTimingSelect = ctx.faultTimingSelect;
    var returnReasonBlock = ctx.returnReasonBlock;
    var returnReasonSelect = ctx.returnReasonSelect;
    var returnConditionCheck = form.querySelector('.cf-return-condition-check');
    var addressChangeBlock = ctx.addressChangeBlock;
    var updatedAddress1 = ctx.updatedAddress1;
    var updatedCity = ctx.updatedCity;
    var updatedPostcode = ctx.updatedPostcode;
    var deliveredChecksBlock = ctx.deliveredChecksBlock;
    var delayedDeliveryCheckBlock = ctx.delayedDeliveryCheckBlock;
    var formWrapper = ctx.formWrapper;
    var detailsStep = ctx.detailsStep;
    var faqSearchInput = ctx.faqSearchInput;
    var FAQ_LIMIT = ctx.FAQ_LIMIT;
    var FAQ_HELPERS = ctx.FAQ_HELPERS;
    var faqContent = ctx.faqContent;

    issueGroups.forEach(function (group) {
      var cat = group.getAttribute('data-category');
      var buttons = group.querySelectorAll('.cf-issue');
      var hidden = group.querySelector('input[type="hidden"]');
      var notice = group.querySelector('.cf-issue-notice');
      var noticeText = group.querySelector('.cf-issue-notice__text');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var val = btn.getAttribute('data-issue') || '';

          if (successBox) {
            successBox.classList.add('cf-hidden');
          }

          if (cat === 'delivery') {
            if (val === 'delivered_no_parcel') {
              ctx.setAttachmentsMode('required');
            } else if (val === 'damaged_items') {
              ctx.setAttachmentsMode('required', 'Attach photos of damage*');
            } else {
              ctx.setAttachmentsMode('hide');
            }
          } else {
            ctx.setAttachmentsMode('hide');
          }

          if (summaryEl && currentCategoryRef.get()) {
            var catLabel = ctx.getCategoryLabel(currentCategoryRef.get());
            summaryEl.textContent =
              'You’re contacting us about: ' + catLabel + ' · ' + btn.textContent.trim();
          }

          if (hidden) {
            hidden.value = val;
          }

          if (!ctx.isApplyingDeepLinkRef.get()) {
            ctx.setChosenReason(null);
            ctx.writeDeepLink({
              cat: currentCategoryRef.get(),
              issue: val,
              faq: ''
            }, 'push');
          }

          buttons.forEach(function (b) {
            b.classList.toggle('is-active', b === btn);
          });

          var msg = (issueCopy[cat] && issueCopy[cat][val]) ? issueCopy[cat][val] : '';
          if (notice && noticeText) {
            if (msg) {
              noticeText.innerHTML = msg;
              notice.classList.remove('cf-hidden');
              void notice.offsetWidth;
              notice.classList.add('is-visible');
            } else {
              noticeText.innerHTML = '';
              notice.classList.remove('is-visible');
              notice.classList.add('cf-hidden');
            }
            ctx.updateDetailsPlaceholder(cat, val);
          }

          if (orderNumberInput) {
            if (val && val !== 'other') {
              orderNumberInput.placeholder = 'Your EG Order Number (EGXXXXX)*';
              orderNumberInput.setAttribute('required', 'required');
            } else {
              orderNumberInput.placeholder = 'Order number (if you have one)';
              orderNumberInput.removeAttribute('required');
            }
          }

          if (cat === 'returns') {
            var isFaulty = (val === 'faulty_item');
            var isChangedMind = (val === 'changed_mind');

            if (productNameBlock) productNameBlock.classList.remove('cf-hidden');
            if (productSerialBlock) productSerialBlock.classList.remove('cf-hidden');

            if (productNameInput) productNameInput.setAttribute('required', 'required');
            if (productSerialInput) productSerialInput.setAttribute('required', 'required');

            if (faultTimingBlock) faultTimingBlock.classList.toggle('cf-hidden', !isFaulty);

            if (faultTimingSelect) {
              if (isFaulty) {
                faultTimingSelect.setAttribute('required', 'required');
              } else {
                faultTimingSelect.removeAttribute('required');
                faultTimingSelect.value = '';
              }
            }

            if (returnReasonBlock) {
              returnReasonBlock.classList.add('cf-hidden');
            }

            if (returnReasonSelect) {
              returnReasonSelect.removeAttribute('required');
              returnReasonSelect.value = '';
            }

            if (returnConditionCheck) {
              var returnConditionCheckbox = returnConditionCheck.querySelector('input[name="contact[Confirmed return condition]"]');

              returnConditionCheck.classList.toggle('cf-hidden', !isChangedMind);

              if (returnConditionCheckbox) {
                if (isChangedMind) {
                  returnConditionCheckbox.setAttribute('required', 'required');
                } else {
                  returnConditionCheckbox.removeAttribute('required');
                  returnConditionCheckbox.checked = false;
                }
              }
            }

            if (isFaulty) {
              ctx.setAttachmentsMode('optional', 'Attach a photo/video of the issue (max 25MB each)');
            }
          } else {
            if (returnConditionCheck) {
              returnConditionCheck.classList.add('cf-hidden');

              var returnConditionCheckbox = returnConditionCheck.querySelector('input[name="contact[Confirmed return condition]"]');
              if (returnConditionCheckbox) {
                returnConditionCheckbox.removeAttribute('required');
                returnConditionCheckbox.checked = false;
              }
            }
            if (productNameInput) {
              productNameInput.removeAttribute('required');
              productNameInput.value = '';
            }
            if (productSerialInput) {
              productSerialInput.removeAttribute('required');
              productSerialInput.value = '';
            }
            if (faultTimingSelect) {
              faultTimingSelect.removeAttribute('required');
              faultTimingSelect.value = '';
            }
          }

          if (addressChangeBlock) {
            var isAddrChange = (cat === 'delivery' && val === 'change_address');

            addressChangeBlock.classList.toggle('cf-hidden', !isAddrChange);

            [updatedAddress1, updatedCity, updatedPostcode].forEach(function (el) {
              if (!el) return;
              if (isAddrChange) el.setAttribute('required', 'required');
              else {
                el.removeAttribute('required');
                el.value = '';
              }
            });
          }

          if (deliveredChecksBlock) {
            var deliveredCheckboxes = deliveredChecksBlock.querySelectorAll('input[type="checkbox"]');
            var showDeliveredChecks = (cat === 'delivery' && val === 'delivered_no_parcel');

            deliveredChecksBlock.classList.toggle('cf-hidden', !showDeliveredChecks);

            deliveredCheckboxes.forEach(function (cb) {
              if (showDeliveredChecks) {
                cb.setAttribute('required', 'required');
              } else {
                cb.removeAttribute('required');
                cb.checked = false;
              }
            });
          }

          if (delayedDeliveryCheckBlock) {
            var delayedCheckboxes = delayedDeliveryCheckBlock.querySelectorAll('input[type="checkbox"]');
            var showDelayedChecks = (cat === 'delivery' && val === 'delayed_delivery');

            delayedDeliveryCheckBlock.classList.toggle('cf-hidden', !showDelayedChecks);

            delayedCheckboxes.forEach(function (cb) {
              if (showDelayedChecks) {
                cb.setAttribute('required', 'required');
              } else {
                cb.removeAttribute('required');
                cb.checked = false;
              }
            });
          }

          var map = issueToFaq[cat] || null;
          var entry = map ? map[val] : null;

          var highlightCtx = ctx.getFaqHighlightContext();
          FAQ_HELPERS.resetFaqHighlight(highlightCtx);
          ctx.setFaqHighlightState(highlightCtx);

          if (cat === 'delivery') {
            var subgroupEl = form.querySelector('.cf-subgroup--' + cat);

            if (subgroupEl) {
              subgroupEl.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
                faqBtn.classList.remove('cf-hidden', 'cf-faq-highlight', 'is-open');
                faqBtn.setAttribute('aria-expanded', 'false');

                var pnl = faqBtn.nextElementSibling;
                if (pnl && pnl.classList.contains('cf-faq-inline')) {
                  pnl.classList.remove('is-open', 'cf-faq-highlight-panel');
                }

                faqBtn.classList.add('cf-hidden');
              });
            }

            var relevantFaqs = [];
            if (Array.isArray(entry)) {
              relevantFaqs = entry;
            } else if (typeof entry === 'string' && entry) {
              relevantFaqs = [entry];
            }

            if (subgroupEl && relevantFaqs.length) {
              relevantFaqs.forEach(function (subreasonId, index) {
                var target = subgroupEl.querySelector(
                  '.cf-reason[data-subreason="' + subreasonId + '"]'
                );
                if (!target) return;

                target.classList.remove('cf-hidden');

                if (index === 0) {
                  ctx.setChosenReason(subreasonId);
                  if (subjectEl) {
                    subjectEl.value = target.getAttribute('data-subject') || '';
                  }

                  var faqCtx = ctx.getFaqOpenContext();
                  FAQ_HELPERS.toggleFaq(faqCtx, target, subreasonId, true, true);
                  ctx.setFaqHighlightState(faqCtx);
                }
              });
            } else if (subgroupEl) {
              subgroupEl.querySelectorAll('.cf-reason').forEach(function (faqBtn) {
                faqBtn.classList.remove('cf-hidden');
              });
            }
          } else {
            var subreason = entry;

            if (subreason) {
              var target = form.querySelector(
                '.cf-subgroup--' + cat + ' .cf-reason[data-subreason="' + subreason + '"]'
              );
              if (target) {
                ctx.setChosenReason(subreason);
                if (subjectEl) {
                  subjectEl.value = target.getAttribute('data-subject') || '';
                }

                var faqCtx = ctx.getFaqOpenContext();
                FAQ_HELPERS.toggleFaq(faqCtx, target, subreason, true, true);
                ctx.setFaqHighlightState(faqCtx);
              }
            }
          }

          if (cat === 'delivery') {
            FAQ_HELPERS.applyFaqLimit({
              form: form,
              faqSearchInput: faqSearchInput,
              FAQ_LIMIT: FAQ_LIMIT
            });
          }

          if (formWrapper) {
            formWrapper.classList.remove('cf-hidden');
          }

          if (detailsStep) {
            detailsStep.classList.remove('cf-hidden');
            void detailsStep.offsetWidth;
            detailsStep.classList.add('cf-visible');
          }

          ctx.syncConditionalFieldSubmission();
        });
      });
    });
  }
};